<template>
  <v-card class="drop-progress">
    <v-subheader>
      <v-icon medium color="error" class="mr-2">trending_down</v-icon>
      {{date}} <span class="ml-2">{{message ? message : 'Скинуто прогресс студента'}}</span>
    </v-subheader>
<!--    <v-layout row>-->
<!--      <v-flex>-->
<!--        <v-card tile flat class="grey lighten-4">-->
<!--          <v-card-text>-->
<!--            <span class="font-weight-medium">Причина: </span>{{reason}}-->
<!--          </v-card-text>-->
<!--        </v-card>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
  </v-card>
</template>

<script>
  export default {
    name: "DropProgress",
    props: ["date", "description", "level", "message"]
  }
</script>

<style scoped>
  .drop-progress {
    border: 1px solid #78909C;
  }

</style>
